import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface TMessage {
  content?: string;
  type: "success" | "error" | "info" | "warning";
}

export interface IApi {
  loading: boolean;
  message?: TMessage;
  refresh: boolean;
}

// Define the initial state using that type
const initialState: IApi = {
  loading: false,
  refresh: false,
};

const apiSlice = createSlice({
  name: "api",
  initialState,
  reducers: {
    loading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    refresh(state, action: PayloadAction<boolean>) {
      state.refresh = action.payload;
    },
    saveSysMessage(state, action: PayloadAction<TMessage>) {
      state.message = {
        content: action.payload.content,
        type: action.payload.type,
      };
    },
    clearSysMessage(state) {
      state.message = undefined;
    },
  },
});

export const { loading, saveSysMessage, refresh, clearSysMessage } = apiSlice.actions;
export default apiSlice.reducer;
